// ImageCard.jsx
import { getImageUrl } from "./utils";

/**
 * Affiche l'image en largeur 100%, sans recadrage.
 * - Largeur: 100%
 * - Hauteur: auto (varie selon le ratio)
 * - Limite: max-h responsive pour éviter qu'une image trop "haute" casse la mise en page
 * 
 * Props optionnelles :
 * - maxH: classes Tailwind pour la hauteur max (par défaut "max-h-80 md:max-h-96 lg:max-h-[32rem]")
 * - fit: "contain" (par défaut) ou "cover" si tu veux recadrer ponctuellement
 */
export default function ImageCard({
  src,
  alt,
  caption,
  onClick,
  maxH = "max-h-80 md:max-h-96 lg:max-h-[32rem]",
  fit = "contain",
}) {
  const resolved = getImageUrl(src);

  return (
    <figure className="rounded-xl overflow-hidden border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-sm">
      <div
        className={`w-full ${maxH} flex items-center justify-center bg-slate-50 dark:bg-slate-800`}
      >
        <img
          src={resolved}
          alt={alt}
          className={`w-full h-auto ${fit === "contain" ? "object-contain" : "object-cover"} cursor-zoom-in`}
          onClick={onClick}
          loading="lazy"
          decoding="async"
          onError={(e) => {
            // feedback visuel si le fichier est manquant
            e.currentTarget.style.opacity = 0.2;
            e.currentTarget.alt = alt ? `${alt} (introuvable)` : "Image introuvable";
          }}
          // Tip: sizes aide le navigateur à choisir la bonne ressource
          sizes="(min-width: 1024px) 40vw, (min-width: 768px) 60vw, 100vw"
        />
      </div>

      {caption && (
        <figcaption className="text-sm text-slate-600 dark:text-slate-300 px-3 py-2">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
